import React, { useMemo } from 'react'
import { AttachmentTypes } from 'logic/patientNotesLogic'
import ImageAttachment from './ImageAttachment'

const NoteAttachment = ({ type, s3Object }) => {
  const attachmentByType = useMemo(
    () => ({
      [AttachmentTypes.Image]: <ImageAttachment s3Object={s3Object} />
    }),
    [s3Object]
  )

  return attachmentByType[type]
}

export default NoteAttachment
